<template>
    <div class="attachements" v-if="attachementList.length!=0">
          <div  class="solidBox"></div>
              <div>
                <h3 class="attchTitle"><span class="icon"></span>附件</h3>
                <div
                  class="rich-box"
                  v-for="(item, index) in attachementList"
                  :key="index"
                >
                  <div
                    class="attachitem"
                    @click="download(item, buildResourcePath(item.location))"
                  >
                    <i
                      class="iconfont iconxiazai"
                      style="font-size: 30px; margin-right: 5px; color: #cbcbd1"
                    ></i
                    ><span class="attachInfoBox"
                      ><div style="line-height: 20px" class="tilBox">
                        {{ item.resourceName }}
                      </div>
                      <div style="line-height: 20px">
                        {{ sizeFormat(item.size) }}
                       <!-- {{ item.size}} -->
                      </div>
                    </span>
                  </div>
                </div>
              </div>
    </div>
</template>
<script>
import util from "@/libs/util.js";
// import NewsContent from "@/components/news/news-Content";
// import Breadcrumb from "@/components/breadcrumb";
// import config from "../config";
export default {
  props: {
    attachementList: {
        type:Array,
         default() {
        return [];
      },
    },
  },
  data() {
    return {
      loading: false,
      newsInfo: null,
      config: {},
      breadList: [],
      menu: [],
      menuId: null,
    };
  },
  created(){
   console.log(this.attachementList);
  },
  methods:{
    sizeFormat(size) {
      return util.sizeFormat(size);
    },
    buildResourcePath(src) {
      return util.buildResourcePath(src);
    },
    download(item, src) {
      src = src + "?attname=" + item.resourceName;
      window.open(src);
    },
  }
}

</script>
<style lang="scss" scoped>
.attachements{
    margin-top: 20px;
}
.solidBox {
  border-bottom: 1px dashed #979797;
}
.attchTitle {
  padding-left: 10px;
  border-left: 3px solid #ec2f08;
}
.IconBox {
  width: 5px;
  height: 5px;
  position: absolute;
  top: 17px;
  left: 22px;
  background: #969696;
}
.rich-box {
  margin-top: 20px;
  margin-bottom: 10px;
  overflow: hidden;
}
.attachitem {
  float: left;
  padding: 4px 5px;
  padding-top: 9px;
  background-color: #fff;
}
.attachitem:hover {
  cursor: pointer;
  color: #ec2f08;
  background-color: #f5f5f5;
  border-radius: 2px;
}
.attachInfoBox {
  font-size: 14px;
  color: #444;
  height: 38px;
  display: inline-block;
  width: 408px;
  z-index: 99;
  margin-left: -40px;
  padding-left: 40px;
  margin-top: -2px;
}
.attachInfoBox:hover {
  color: #ec2f08;
}
.attachInfoBox:hover::after {
  content: "下载";
  display: inline-block;
  margin-right: 5px;
  margin-top: -32px;
  float: right;
}
.tilBox {
  width: 330px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@media (max-width: 767px) {
  .contentBox{
    border: none;
    min-height: calc(100vh - 125px);
  }
  .content{
    margin-top:20px;
    padding-top: 0px;
    margin-bottom:30px;
  }
  .rich-text-wrapper {
    padding: 0;
    background-color: unset;
    border: unset;
  }

  .rich-text-wrapper h1 {
    font-size: 18px;
    line-height: 30px;
  }

  .rich-text-wrapper .info {
    margin: 10px 0;
  }
    .attchTitle {
    padding-left: 16px;
  }
  .attachInfoBox {
    width: calc(100vw - 125px) !important;
  }
  .tilBox {
    width: calc(100vw - 125px) !important;
  }
  .attachInfoBox:hover::after {
    display: none;
  }
  .titleBox {
    padding: 20px 0px;
    margin-left: -20px;
    margin-right: -20px;
    background-color: #fff;
    border-top: 1px solid #e3e3e9;
    padding-top: 20px !important;
  }
}
</style>
